export enum BoatConnectionStatus {
	Online = 'ONLINE',
	Offline = 'OFFLINE',
	Warning = 'WARNING',
}
